export const userRole = {
  corporateAdmin: "CORPORATE_ADMIN",
  individual: "INDIVIDUAL",
  superAdmin: "SUPER_ADMIN",
};
